import {
  Stack,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { bold } from '@styles/fontWeights';
import {
  PayrollPartners,
} from '@features/digitalOnboarding';
import { Delete, Edit, Email } from '@mui/icons-material';

function EnterpriseOnboardingPayrollPartners({
  payrollPartners,
  setPayrollData,
  setIsPayrollPartnerModalOpen,
  setIsDeletingModalOpen,
}: {
  payrollPartners: PayrollPartners[];
  setPayrollData: (data: PayrollPartners) => void;
  setIsPayrollPartnerModalOpen: (value: boolean) => void;
  setIsDeletingModalOpen: (value: boolean) => void;
}) {
  return (
    <Stack width="100%">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Partner Name</strong>
              </TableCell>
              <TableCell>
                <strong>Company Name</strong>
              </TableCell>
              <TableCell>
                <strong>Email</strong>
              </TableCell>
              <TableCell align="right">
                <strong>Actions</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payrollPartners.map((item: PayrollPartners) => (
              <TableRow key={item.onboarding_partner_email}>
                <TableCell>
                  <Typography variant="h6" sx={{ fontWeight: bold, maxWidth: '400px', wordBreak: 'break-word' }}>
                    {item.onboarding_partner_name}
                  </Typography>
                </TableCell>
                <TableCell sx={{ maxWidth: '400px', wordBreak: 'break-word' }}>{item.onboarding_partner_company_name}</TableCell>
                <TableCell>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Email sx={{ fontSize: '14px' }} />
                    <Typography variant="body1" sx={{ maxWidth: '400px', wordBreak: 'break-word' }}>
                      {item.onboarding_partner_email}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell align="right">
                  <Stack direction="row" spacing={2} justifyContent="end">
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      startIcon={<Edit />}
                      onClick={() => {
                        setPayrollData(item);
                        setIsPayrollPartnerModalOpen(true);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      startIcon={<Delete />}
                      onClick={() => {
                        setPayrollData(item);
                        setIsDeletingModalOpen(true);
                      }}
                    >
                      Delete
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}

export default EnterpriseOnboardingPayrollPartners;
